/**
  * Hotspot-Aufgabe: Auswählen eines Bereichs in einem Bild.
  * @namespace v3sWbtPlayerApp:exercise:hotspot
  */
/**
 * Ermöglicht die Anzeige von Hotspot-Aufgaben.
 * @class directive_v3sHotspot
 * @memberOf v3sWbtPlayerApp:exercise:hotspot
 */
angular.module('v3sWbtPlayerApp').directive('v3sHotspot', ["$tooltip", "v3sHotspotElement", "v3sContentMediaPath", function ($tooltip, v3sHotspotElement, v3sContentMediaPath) {
    return {
        restrict: 'E',
        scope: {
            id: '@',
            v3sWidth: '@',
            v3sHeight: '@',
            v3sTop: '@',
            v3sLeft: '@',
            v3sFile: '@'
        },
        require: ['^v3sDocument', 'v3sHotspot'],
        transclude: true,
        controller: ["$scope", "$element", function ($scope, $element) {
            /**
             * Erstellt ein Element, das einen Klick repräsentiert
             * @param {number} x x-Koordinate relativ zur Hotspot-Aufgabe
             * @param {number} y y-Koordinate relativ zur Hotspot-Aufgabe
             * @returns {Object} das erstellte ClickElement
             */
            $scope.createClickElement = function (x, y) {
                var clickElement = angular.element("<span class='click'></span>");
                clickElement.css("left", x + "px");
                clickElement.css("top", y + "px");
                clickElement.bind("click", function () {
                    if (!$scope.element.mapareas[0].completed) {
                        $scope.element.setUserAnswer(x, y, this);
                        angular.element(this).remove();
                        //hide Tooltip
                        var tooltip = angular.element(document.querySelector(".tooltip"));
                        tooltip.remove();

                    }
                });

                return clickElement;
            };
        }],
        // TODO wieder URL verwenden, wenn Bug #13680 behoben ist
        templateUrl: "app/js/exercise/hotspot/hotspot.tpl.html",
        link: function (scope, element, attrs, ctrls, transclude) {
            var v3sDocumentCtrl = ctrls[0];
            var v3sHotSpotCtrl = ctrls[1];
            var tooltip = null;

            scope.element = new v3sHotspotElement(scope.v3sTop, scope.v3sLeft);

            transclude(scope, function (clone, scope) {
                angular.forEach(clone, function (node, index) {
                    var tagName = node.tagName.toLowerCase();

                    if (tagName === "v3s-maparea") {
                        var el = angular.element(node);

                        var width = el.attr("v3s-width");
                        var height = el.attr("v3s-height");
                        var left = el.attr("v3s-left");
                        var top = el.attr("v3s-top");
                        var id = el.attr("id");

                        var maparea = scope.element.addMaparea(id, true, width, height, left, top);

                        //Anzeigen der gespeicherten Klicks der erstellten mapareas
                        angular.forEach(maparea.userAnswer, function (answer) {
                            var clickElement = scope.createClickElement(answer.x, answer.y);
                            element.append(clickElement);
                            maparea.addClick(clickElement);
                        });
                    }
                });

                /**
                 * Diese maparea "speichert" die falschen Klicks
                 * Sie wird im Controller gespeichert, da die anderen mapareas eventuell
                 * Klicks von ihr löschen müssen beim Feedback
                 */
                v3sHotSpotCtrl.incorrectMaparea = scope.element.addMaparea("ma_incorrect", false, scope.v3sWidth, scope.v3sHeight, scope.v3sLeft, scope.v3sTop);

                //Anzeigen der gespeicherten Klicks der inkorrekten maparea
                angular.forEach(v3sHotSpotCtrl.incorrectMaparea.userAnswer, function (answer) {
                    var clickElement = scope.createClickElement(answer.x, answer.y);
                    element.append(clickElement);
                    v3sHotSpotCtrl.incorrectMaparea.addClick(clickElement);
                });

            });

            element.addClass("hotspotArea");

            if (scope.v3sFile) {
                var imgPath = v3sContentMediaPath + scope.v3sFile;
                element.css("background-image", "url(" + imgPath + ")");
            }


            //not draggable
            element.attr("data-clickable", "true");

            element.bind('click', function (event) {
                if (!scope.element.mapareas[0].completed) {
                    if (!!tooltip) {
                        tooltip.hide();
                    }
                    var x = event.offsetX || event.layerX;
                    var y = event.offsetY || event.layerY;

                    if (event.target === element[0]) {

                        //Ein neues ClickElement erstellen und hinzufügen
                        var clickElement = scope.createClickElement(x, y);
                        element.append(clickElement);

                        //Welche maparea wurde getroffen
                        scope.element.setUserAnswer(x, y, clickElement);
                    }
                }
            });

            // Annotieren aktivieren
            v3sDocumentCtrl.addElement(element);
        }
    };
}]);
